import { render, staticRenderFns } from "./PriceAndTax.vue?vue&type=template&id=6df2467a&scoped=true&lang=pug&"
import script from "./PriceAndTax.vue?vue&type=script&lang=js&"
export * from "./PriceAndTax.vue?vue&type=script&lang=js&"
import style0 from "./PriceAndTax.vue?vue&type=style&index=0&id=6df2467a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df2467a",
  null
  
)

export default component.exports